import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { getNewStateById } from './entities';
import { fetchFantasyEventGames } from './fantasyEventGames';
import { fetchFantasyEvents } from './fantasyEvents';
const initialState = {
    byId: {},
    status: 'init'
};
export const fetchOutcomes = createAsyncThunk('outcomes/fetch', async (options, thunkApi) => {
    try {
        return await (await api.instance).fetchOutcomes(options);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
const outcomesSlice = createSlice({
    name: 'outcomes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOutcomes.fulfilled, (state, action) => {
            state.byId = getNewStateById(state.byId, action.payload);
            state.status = 'success';
        })
            .addCase(fetchFantasyEvents.fulfilled, (state, action) => {
            state.byId = getNewStateById(state.byId, action.payload.outcomes);
        })
            .addCase(fetchFantasyEventGames.fulfilled, (state, action) => {
            action.payload.forEach((fantasyEventGame) => {
                state.byId = getNewStateById(state.byId, fantasyEventGame.outcomes);
            });
        })
            .addCase(fetchOutcomes.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(fetchOutcomes.rejected, (state) => {
            state.status = 'error';
        });
    }
});
export const outcomesReducer = outcomesSlice.reducer;
